<template>
  <v-dialog v-model="dialogView" persistent max-width="350">
    <v-card v-if="selectedRow">
      <v-card-title class="text-h5" v-if="selectedRow.status === 'clockedIn'">
        Clock Out
      </v-card-title>
      <v-card-title class="text-h5" v-else> Clock In </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <v-row class="pt-5">
          <v-col cols="12">
            <div v-if="selectedRow.status === 'clockedIn'">Clock Out</div>
            <div v-else>Clock In</div>
            <!-- <DateTimeTextField
              v-if="selectedRow.status === 'clockedIn'"
              v-model="clockOutTime"
              :initDate="clockOutTime"
            /> -->
            <DateTimeTextField
              v-model="clockTime"
              :initDate="clockTime"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="red darken-1" text @click.stop.prevent="cancel"> Cancel </v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="submitWithClockIn"
          :loading="submitLoading"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import timeClockService from "@/modules/TimeClock/service.js";
import DateTimeTextField from "@/components/DateTimeTextField.vue";

export default {
  props: ["dialog", "selectedRow"],
  data() {
    return {
      dialogView: false,
      clockTime: null,
      submitLoading: false,
    };
  },
  components: { DateTimeTextField },
  watch: {
    dialog(val) {
      this.dialogView = !this.dialogView;
      // console.log('this.selectedRow', this.selectedRow)
      if (val) this.clockTime = this.$moment();
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    submitWithClockIn() {
      this.submitLoading = true;
      // console.log('this.selectedRow', this.selectedRow)
      let selectedRow = this.selectedRow; //JSON.parse(JSON.stringify(this.selectedRow))
      
      if (selectedRow.status === "clockedIn") {
        selectedRow.clockOutTime = this.clockTime;
        selectedRow.admin = true;
        console.log("clock out");
        timeClockService
          .clockOut(selectedRow)
          .then(() => {
            this.submitLoading = false;
            this.$emit("submit");
          })
          .catch((err) => {
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 3000,
            });
            this.submitLoading = false;
            console.log(err ? err.message : err);
          });
      } else {
        selectedRow.clockInTime = this.clockTime;
        selectedRow.admin = true;
        console.log("clock in");
        timeClockService
          .clockIn(selectedRow)
          .then(() => {
            this.submitLoading = false;
            this.$emit("submit");
          })
          .catch((err) => {
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 3000,
            });
            this.submitLoading = false;
            console.log(err ? err.message : err);
          });
      }
    },
  },
};
</script>

<style scoped>
</style>